<template>
  <div class="mails-container">
    <h1 class="title is-5">Emails</h1>

    <emails-login />
    <br>
    <br>
    <compose-button />
    <br>
    <br>
    <compose-box />
    <br>
    <br>
    <!-- <emails-list></emails-list> -->
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import ComposeBox from '../../modules/emails/compose/ComposeBox'
import ComposeButton from '../../modules/emails/compose/ComposeButton'
import EmailsLogin from './EmailsLogin'
import EmailsList from './EmailsList'

export default {
  components: {
      ComposeBox,
      ComposeButton,
      EmailsList,
      EmailsLogin,
   },
  computed: {
    ...mapGetters([
        'emails_is_signed_in',
    ]),
    isSignedIn() {
        return this.emails_is_signed_in
    }
  },
  data() {
    return {
    }
  },
  methods: {
    ...mapActions([
    ]),
  },
  mounted() {
    // if(!this.emails_is_signed_in) {
    //     this.$router.push({ path: "/emails/login" })
    // }
  },
}
</script>

<style>
/*.mails-container*/
</style>